var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_4794)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 0 32)",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2105 12.1945L16.6934 16.7115C16.6017 16.8033 16.5045 16.8691 16.402 16.9091C16.2994 16.949 16.19 16.969 16.0738 16.969C15.9575 16.969 15.8481 16.949 15.7456 16.9091C15.6431 16.8691 15.5459 16.8033 15.4542 16.7115L10.9216 12.1789C10.7499 12.0072 10.6641 11.7981 10.6641 11.5515C10.6641 11.3049 10.7499 11.0957 10.9216 10.924C11.0932 10.7524 11.305 10.6691 11.5568 10.6743C11.8086 10.6795 12.0203 10.7679 12.192 10.9396L16.0738 14.8214L19.9711 10.924C20.1428 10.7524 20.3494 10.6665 20.5908 10.6665C20.8322 10.6665 21.0388 10.7524 21.2105 10.924C21.3821 11.0957 21.4679 11.3074 21.4679 11.5592C21.4679 11.8111 21.3821 12.0228 21.2105 12.1945Z",
    fill: "#4A4D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2105 19.7989L16.6934 15.2819C16.6017 15.1902 16.5045 15.1243 16.402 15.0843C16.2994 15.0444 16.19 15.0244 16.0738 15.0244C15.9575 15.0244 15.8481 15.0444 15.7456 15.0843C15.6431 15.1243 15.5459 15.1902 15.4542 15.2819L10.9216 19.8145C10.7499 19.9862 10.6641 20.1953 10.6641 20.4419C10.6641 20.6886 10.7499 20.8977 10.9216 21.0694C11.0932 21.2411 11.305 21.3243 11.5568 21.3191C11.8086 21.3139 12.0203 21.2255 12.192 21.0538L16.0738 17.172L19.9711 21.0694C20.1428 21.2411 20.3494 21.3269 20.5908 21.3269C20.8322 21.3269 21.0388 21.2411 21.2105 21.0694C21.3821 20.8977 21.4679 20.686 21.4679 20.4342C21.4679 20.1823 21.3821 19.9706 21.2105 19.7989Z",
    fill: "#4A4D53"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.611754,
    y: 31.3882,
    width: 30.7765,
    height: 30.7765,
    rx: 15.3882,
    transform: "rotate(-90 0.611754 31.3882)",
    stroke: "white",
    strokeWidth: 1.22351
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_4794"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 0 32)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modalCloseIcon.26f0edbe.svg";
export { ForwardRef as ReactComponent };